<template>
    <set-azure-cme-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('updatingAzureCmeAccount')"
        :edit="edit"
        :disabled="{ ...(disabled || {}), Name: true, UseTenantCurrencies: true }"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <put-credential-button
                type="AzureEntraApplicationWithStorageCredential"
                :value="{ ...edit, ...form }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'updatingAzureCmeAccount'"
                @http2xx="acceptSubmit($event, close)"
            ></put-credential-button>
        </template>
    </set-azure-cme-credentials-dialog>
</template>

<script>
import SetAzureCmeCredentialsDialog from '@/components/Settings.CloudAccounts/Azure/SetAzureCmeCredentialsDialog';
import PutCredentialButton from '@/components/Settings.CloudAccounts/PutCredentialButton';
export default {
    components: { SetAzureCmeCredentialsDialog, PutCredentialButton },
    props: {
        value: Boolean,
        edit: Object,
        disabled: Object,
    },
    methods: {
        async acceptSubmit($event, close) {
            await close();
            this.$emit('http2xx', $event);
        },
    },
};
</script>